import { Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import LoadingScreen from './LoadingScreen';
import AccessErrorScreen from './AccessErrorScreen';

export default function ProtectedRoute({ children, requireRole }) {
  const { user, profile, loading } = useAuth();

  if (loading) return <LoadingScreen />;
  if (!user) return <Navigate to="/login" replace />;
  // Authenticated but no usable profile/company — show a clear access error
  // instead of bouncing to /login (which would loop, since the user is signed in).
  if (!profile || !profile.companyId) return <AccessErrorScreen />;

  if (requireRole && profile.role !== requireRole) {
    if (profile.role === 'admin') return <Navigate to="/admin" replace />;
    return <Navigate to="/production" replace />;
  }

  return children;
}
